<template lang="pug">
  section
    s-page-title(
      :previous='true'
      :title='id ? "Редактирование FAQ" : "Добавление FAQ"'
    )
    v-card
      v-tabs(v-model='active' color='dark' slider-color='primary')
        v-tab Основное
        v-tab-item(:transition='false' :reverse-transition='false')
          v-container(grid-list-xl fluid)
            v-layout(wrap)
              v-flex(xs12 sm12)
                div(class="picker")
                  s-publish-date-status(
                    :errors='errors'
                    :model='item'
                  )
              v-flex(xs12)
                v-text-field(
                  :error='errors.has("question")'
                  :error-messages='errors.first("question")'
                  v-model='item.question'
                  label='Вопрос'
                )
              v-flex(v-if="editor" xs12)
                div(class='subheading font-weight-medium mb-3') Ответ
                ckeditor(v-model='item.answer')
              v-flex(xs12)
                s-region-picker(
                  v-model='regions'
                  chips
                  multiple
                )
          v-card-actions(class='large')
            v-spacer
            s-back-btn
            v-btn(
              @click='onSave'
              :loading='isLoading'
              color='primary'
              depressed
            ) Сохранить
        v-tab(v-if='id') Группы
        v-tab-item(:transition='false' :reverse-transition='false')
          v-container(grid-list-xl fluid)
            v-layout(wrap)
              v-flex(xs10)
                v-select(
                  v-if='attributes'
                  :error='errors.has("faq_groups")'
                  :error-messages='errors.first("faq_groups")'
                  :items='groupsList'
                  item-text='name'
                  item-value='id'
                  v-model='group'
                  label='Выберите группу'
                )
              v-flex(xs2)
                v-btn(
                  @click='addGroup'
                  :style='{ margin: 0 }'
                ) Добавить
            v-layout(wrap v-for='(block, index) in groups' :key='block.id' class='group-block')
              v-flex(xs10) {{ block.name }}
              v-flex(xs2)
                v-btn(
                  @click='deleteGroup(block)'
                  :style='{ margin: 0 }'
                ) Удалить
</template>

<script>
import http from '@/http'
import { mapActions, mapGetters } from 'vuex'
import { differenceBy } from 'lodash'

export default {
  props: ['id'],

  components: {
    Ckeditor: () => import('@/components/async/Ckeditor')
  },

  data: () => ({
    item: {},
    group: null,
    groups: [],
    active: 0,
    attributes: {},
    bErrors: {},
    editor: true,
    sorting: {
      opened: false,
      itemValue: 'id',
      itemText: 'name',
      renderFn(item) {
        if (item.name) return item.part + ` ` +item.name
        return item.part + ` ` +`<img src="${item.picture_url}" width="120"/>`
      }
    }
  }),

  async created() {
    this.fetchAttributes()
    if (!this.id) return
    this.updateItem()
    this.fetchGroups()
  },

  methods: {
    async updateItem() {
      const response = await this.fetchSingle({ id: this.id })
      this.item = response.data
    },

    async onSave() {
      const data = this.item
      try {
        if (this.id) await this.update({ id: this.id, data })
        else await this.create({ data })
        this.$root.showSnack('Сохранено')
        if(!this.id)
          this.$router.push({ name: 'Seo.Faq' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    async fetchGroups() {
      try {
        const res = await http.get(`/seo/faqs/${this.id}/groups`)
        this.groups = res.data
      } catch(error) {
        this.$root.showSnack('Ошибка загрузки групп')
      }
    },

    async fetchAttributes() {
      try {
        const res = await http.get('/seo/faqs/attributes')
        this.attributes = res.data
      } catch(error) {
        this.$root.showSnack('Ошибка загрузки атрибутов')
      }
    },

    async addGroup() {
      if (!this.group) return
      try {
        await http.post(`seo/faqs/${this.id}/groups/${this.group}`)
        this.fetchGroups()
      } catch(error) {
        this.$root.showSnack('Ошибка добавления группы')
      }
    },

    async deleteGroup(group) {
      try {
        await http.delete(`seo/faqs/${this.id}/groups/${group.id}`)
        this.fetchGroups()
      } catch(error) {
        this.$root.showSnack('Ошибка удаления группы')
      }
    },

    ...mapActions('seo/faq', ['fetchSingle', 'update', 'create'])
  },

  computed: {
    groupsList() {
      if (!this.attributes.faq_groups) return []
      return differenceBy(this.attributes.faq_groups, this.groups, 'id')
    },
    regions: {
      get: function() {
        if (!this.item.regions) return []
        return this.item.regions.split(',')
      },
      set: function(val) {
        this.item.regions = val.join(',')
      }
    },

    ...mapGetters('seo/faq', ['isLoading'])
  }
}
</script>

<style scoped>
.small textarea {
  font-size: 12px;
}
</style>
